// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const FINE_PARTY_BASES = ['individual', 'organization'];
// ── Enforcement-register marks (org-recorded, Sprint 62.35.0 Slice A) ──
export const AREA_REMEDIATION_STATUSES = ['open', 'in_progress', 'remediated', 'accepted'];
/**
 * The two regime options that are not framework codes. The other two options
 * of any area are read from its record: its own framework code and the code in
 * its `enforcement_regime.excluded_regime_framework_code`.
 */
export const REGIME_FIXED_OPTIONS = ['split_by_act', 'not_determined'];
/**
 * The regime options for one area, read from its installed record. An area
 * that declares no excluded regime has nothing to route between, so the only
 * option is `not_determined`. One function, shared by the server's validator and
 * the read model, so the two cannot offer different sets.
 */
export function regimeOptionsForArea(area, anchorFrameworkCode) {
    const regime = area.enforcement_regime;
    if (!regime || !regime.excluded_regime_framework_code)
        return ['not_determined'];
    // The area's OWN framework, as the record names it (the spec's wording);
    // the anchor document's code only where the record carries none.
    const own = area.framework_code || anchorFrameworkCode;
    if (own === regime.excluded_regime_framework_code)
        return ['not_determined'];
    return [own, regime.excluded_regime_framework_code, ...REGIME_FIXED_OPTIONS];
}
/**
 * Sprint 62.20.0 (AC6) — `not_an_obligation` is a fifth, first-class reading.
 *
 * Before it, an area of a not-yet-promulgated framework declaring no
 * `applicable_modules` came out `unmapped` — indistinguishable from a real
 * coverage gap on an instrument that binds. Fifteen such rows were attributed
 * to a legislative-program draft on the readiness map.
 */
export const AREA_READINESS_STATUSES = [
    'evidenced',
    'partially_evidenced',
    'exposed',
    'unmapped',
    'not_an_obligation',
];
// ── Collections ──
export const PENALTY_EXPOSURE_INPUTS_COLLECTION = 'grc_penalty_exposure_inputs';
// ── Error codes ──
export const PENALTY_EXPOSURE_ERROR_CODES = {
    INPUTS_NOT_FOUND: 'PENALTY_EXPOSURE_INPUTS_NOT_FOUND',
    INVALID_SCHEDULE: 'PENALTY_EXPOSURE_INVALID_SCHEDULE',
    // Sprint 62.35.0 (Slice A) — the enforcement-register mark fields.
    REGIME_OPTION_INVALID: 'PENALTY_EXPOSURE_REGIME_OPTION_INVALID',
    MEASURE_NOT_IN_AREA: 'PENALTY_EXPOSURE_MEASURE_NOT_IN_AREA',
    EVIDENCE_NOT_IN_AREA: 'PENALTY_EXPOSURE_EVIDENCE_NOT_IN_AREA',
    OWNER_NOT_FOUND: 'PENALTY_EXPOSURE_OWNER_NOT_FOUND',
    OWNER_DEADLINE_REQUIRED: 'PENALTY_EXPOSURE_OWNER_DEADLINE_REQUIRED',
    REGIME_REASONS_REQUIRED: 'PENALTY_EXPOSURE_REGIME_REASONS_REQUIRED',
    AREA_NOT_INSTALLED: 'PENALTY_EXPOSURE_AREA_NOT_INSTALLED',
    /**
     * Gate E12.5 pass 2 (P1-A) — `PUT /inputs` names the `updated_at` it read
     * (`expected_updated_at`), and the document had moved since: someone else
     * saved in between, and writing this copy back would revert their work.
     */
    INPUTS_CONFLICT: 'PENALTY_EXPOSURE_INPUTS_CONFLICT',
};
//# sourceMappingURL=penalty-exposure.js.map